import { render, staticRenderFns } from "./IconMyPage.vue?vue&type=template&id=3057cd53"
import script from "./IconMyPage.vue?vue&type=script&lang=ts"
export * from "./IconMyPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports